module.exports = __webpack_public_path__ + "img/indexTab.ec4f5665.png";